export const CODE_WORD_WRAP_STORAGE_KEY = "turbonotes2-code-word-wrap";

export interface CodeBlockSettings {
  wordWrap: boolean;
}

export const DEFAULT_CODE_BLOCK_SETTINGS: Readonly<CodeBlockSettings> = {
  wordWrap: false,
};

export function loadCodeBlockSettings(storage: Pick<Storage, "getItem">): CodeBlockSettings {
  return {
    wordWrap: storage.getItem(CODE_WORD_WRAP_STORAGE_KEY) === "true",
  };
}
